// extracted by mini-css-extract-plugin
var _1 = "XhLqd";
var _2 = "N1sHc";
var _3 = "ZAUGm";
export { _1 as "upsellImage", _2 as "upsellItem", _3 as "upsellList" }
